import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';
import { AcModel } from '../../models/ac.model';
import { AuthStateService } from '../../services/auth-state.service';

export enum AcSelectorModes {
  Login = 'login',
  Change = 'change',
}

@Component({
  selector: 'app-ac-selector',
  templateUrl: './ac-selector.component.html',
  styleUrls: ['./ac-selector.component.scss']
})
export class AcSelectorComponent implements OnInit, OnChanges {

  @Input() loading = false;
  @Input() mode: AcSelectorModes = AcSelectorModes.Login;
  @Input() acs: Array<AcModel> = [];
  @Output() selected = new EventEmitter<AcModel>();
  @Output() cancelled = new EventEmitter<void>();

  public userTimezone: string | null = null;

  public faExclamationTriangle = faExclamationTriangle;
  public AcSelectorModes = AcSelectorModes;


  constructor(
    private auth: AuthStateService
  ) { }

  ngOnInit(): void {
    this.auth.user$.subscribe({
      next: (user: any) => {
        if (user?.timezone) {
          this.userTimezone = user.timezone;
        }
      }
    });
  }

  ngOnChanges(): void {
    this.sortAcs();
  }

  public selectAc(ac: AcModel): void {
    this.selected.emit(ac);
  }

  public cancelAcList(): void {
    this.cancelled.emit();
  }

  private sortAcs(): void {
    const statusList = [
      {
        name: 'running',
        factor: 1,
        index: 'A'
      },
      {
        name: 'planned',
        factor: 1,
        index: 'B'
      },
      {
        name: 'finished',
        factor: -1,
        index: 'C'
      },
      {
        name: 'cancelled',
        factor: -1,
        index: 'D'
      },
    ];
    let temp = [];
    statusList.forEach((status: any) => {
      temp = [
        ...temp,
        ...this.acs
          .filter((ac: AcModel) => ac.status === status.name)
          .sort((a: AcModel, b: AcModel) => (a.start_time - b.start_time) * status.factor)
          .map((ac: AcModel) => {
            ac.temp = status.index;
            return ac;
          })
      ];
    });
    this.acs = temp;
  }

}
